import { IStringDate } from './types';
import { getLastDayOfMonth } from './getLastDayOfMonth';
export const endOfMonth = (date: IStringDate): IStringDate => {
  const month = date.split('-')[1];
  const year = date.split('-')[0];
  return `${year}-${month}-${getLastDayOfMonth(date)}`;
};
